// @flow

import React from 'react'
import styled from 'styled-components'
import Path from 'routes/path'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'

const MenuLinkTextComponent = styled.div`
  &::after {
    clear: both;
    content: '';
    display: block;
  }
`

const MenuLinkTextBack = styled.div`
  float: left;
  text-align: right;
  vertical-align: bottom;
`

const MenuLinkTextRight = styled.div`
  float: right;
  text-align: right;
  vertical-align: bottom;
`

const DeleteLinkText = styled.div`
  display: inline-block;
  margin-left: ${spacing.small_3}px;
`

export type PropTypes = {
  onClickBackLink: (e: Event) => void,
  onClickChangeName: (e: Event) => void,
  onClickDelete: (e: Event) => void,
}

export default class MenuLinkText extends React.Component<PropTypes, *> {
  props: PropTypes

  render() {
    const { onClickBackLink, onClickChangeName, onClickDelete } = this.props

    return (
      <MenuLinkTextComponent>
        <MenuLinkTextBack>
          <LinkText
            fontSizeSp={fontSize.small_3}
            href={Path.favoriteLists()}
            onClick={onClickBackLink}
          >
            <Icon className="fa fa-angle-left" positionType="left" />
            {i18n.t('page.shared.l_00003')}
          </LinkText>
        </MenuLinkTextBack>
        <MenuLinkTextRight>
          <LinkText fontSizeSp={fontSize.small_3} onClick={onClickChangeName}>
            <Icon className="fa fa-pencil" positionType="left" />
            {i18n.t('page.dashboard.favorite.changeListName')}
          </LinkText>
          <DeleteLinkText>
            <LinkText fontSizeSp={fontSize.small_3} onClick={onClickDelete}>
              <Icon className="fa fa-trash" positionType="left" />
              {i18n.t('page.shared.delete')}
            </LinkText>
          </DeleteLinkText>
        </MenuLinkTextRight>
      </MenuLinkTextComponent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/MenuLinkText/index.jsx